<template>
  <div>
    <section v-for="(data, idx) in dataResponse" :key="idx" :class="'text-image container bg-wht ' + data.fields.imagePosition"
      :id="data.fields.title.toLowerCase().replaceAll(' ', '-')" >
      <div class="content content-centered content-roomy trimmed-width-3 d-grid column-gap-4 row-gap-3">
        <div class="group-description">
          <h3>{{ data.fields.title }}</h3>
          <p>{{ data.fields.text_01 }}</p>
          <div class="read-more-container" v-if="data.fields.text_02">
            <input type="checkbox" :id="'check_'+data.fields.title.toLowerCase().replaceAll(' ', '-')">
            <div v-html="$sanitize($markdown.makeHtml(data.fields.text_02))"></div>
            <label class="btn btn-max mt-3" :for="'check_'+data.fields.title.toLowerCase().replaceAll(' ', '-')">
              <i class="icon-"></i>
              <span>{{data.fields.linkOptional}}</span>
            </label>
          </div>
        </div>
        <div class="group-images">
          <img :src="data.fields.image.fields.file.url" class="my-3" :alt="data.fields.image.fields.title">
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import { getContent } from '@/javascripts/contentful';

  export default {
    name: 'textWithImageApp',
    props: ["dataResponse"],
    data() {
      return {
        dataWasDownloadedSuccessfully: false,
        message: "",
        flickityOptions: {
          "fade": true,
          "autoPlay": 12000,
          "prevNextButtons": false,
          "pageDots": true,
          "imagesLoaded": true,
          "pauseAutoPlayOnHover": false
        }
      }
    }
  }
</script>
